export const bgTitleSizes = {
  smaller: 'smaller', // card home
  small: 'small',
  medium: 'medium',
};

export const stylingBySize = {
  [bgTitleSizes.smaller]: {
    lineHeight: '32px',
    padding: '3px 8px',
    letterSpacing: '0.07em',
    fontSize: 'f6',
  },
  [bgTitleSizes.small]: {
    lineHeight: 1.9,
    padding: '3px 10px',
    letterSpacing: '0.05em',
    fontSize: 'f5',
  },
  [bgTitleSizes.medium]: {
    lineHeight: 1.9,
    padding: '5px 20px',
    letterSpacing: '0.08em',
    fontSize: 'f4',
  },
};
